import { Component, AfterViewInit, OnInit } from '@angular/core';
import { NavBarService } from '../../../services/nav-bar/nav-bar.service';
import { LanguageService } from '../../../services/languages/language.service';
import { BaseHttpService } from '../../../services/base-http/base-http.service';
import { Offer } from '../../../models/Offer';
import { OffersService } from '../../../services/offers/offers.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterTableService } from 'src/app/services/offers/filter-table.service';

@Component({
  selector: 'app-offer-table',
  templateUrl: './offer-table.component.html',
  styleUrls: ['./offer-table.component.scss'],
})
export class OfferTableComponent implements OnInit {
  routes = ['sales', 'rents'];
  offersFilterVisible = false;
  maxMiddlePagesCount = 5;
  maxPages: number;
  middlePagesCount: number;
  middlePages: number[];
  maxOffersPerPage = 12;
  selectedFilteredPageIndex = 1;
  canShowLeftDots: boolean;
  canShowRightDots: boolean;
  shownOffers: Offer[];
  currentPath: string;
  language: string;
  isRentable: boolean;

  public sortedByPrice = '';

  constructor(
    private nav: NavBarService,
    public httpService: BaseHttpService,
    public ls: LanguageService,
    public fts: FilterTableService,
    public offersService: OffersService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.ls.currentLanguageKey.subscribe((lg) => (this.language = lg));
    this.route.url.subscribe((data) => {
      this.currentPath = data[0].path;
    });
    this.fts.updateOffers.subscribe(() => {
      this.selectedFilteredPageIndex = Number(
        this.route.snapshot.paramMap.get('id')
      );
      this.refreshPage();
    });

    setTimeout(() => {
      if (this.currentPath === this.routes[0]) {
        this.nav.deselectAll();
        this.nav.estatesSelected = true;
        this.nav.salesSelected = true;
      }
      if (this.currentPath === this.routes[1]) {
        this.nav.deselectAll();
        this.nav.estatesSelected = true;
        this.nav.rentsSelected = true;
      }
    }, 0);
    this.selectedFilteredPageIndex = Number(
      this.route.snapshot.paramMap.get('id')
    );
    this.refreshPage();
  }

  sortByPrice(sortPrice: string) {
    if (this.fts.selectedOffers) {
      this.fts.selectedOffers.sort((x, y) => {
        return sortPrice === 'ascending'
          ? Number(x.price.replace(' ', '')) - Number(y.price.replace(' ', ''))
          : Number(y.price.replace(' ', '')) - Number(x.price.replace(' ', ''));
      });
    }
    this.refreshPage();
  }

  sortBySpace(sortedSpace: string): void {
    if (this.fts.selectedOffers) {
      this.fts.selectedOffers.sort((x, y) => {
        return sortedSpace === 'ascending'
          ? x.space - y.space
          : y.space - x.space;
      });
    }
    this.refreshPage();
  }

  clickNextPage() {
    if (this.selectedFilteredPageIndex < this.maxPages) {
      this.selectedFilteredPageIndex++;
      this.router.navigate([
        this.language +
          '/estates/' +
          this.currentPath +
          '/' +
          this.selectedFilteredPageIndex,
      ]);
    }
  }

  clickPageIndex(index: number) {
    this.selectedFilteredPageIndex = index;
    this.router.navigate([
      this.language +
        '/estates/' +
        this.currentPath +
        '/' +
        this.selectedFilteredPageIndex,
    ]);
  }

  clickPreviousPage() {
    if (this.selectedFilteredPageIndex > 1) {
      this.selectedFilteredPageIndex--;
      this.router.navigate([
        this.language +
          '/estates/' +
          this.currentPath +
          '/' +
          this.selectedFilteredPageIndex,
      ]);
    }
  }

  public ClickFilterButton(): void {
    if (!this.offersFilterVisible) {
      this.showFilterMenu();
    } else {
      this.hideFilterMenu();
    }
  }

  public hideFilterMenu(): void {
    this.offersFilterVisible = false;
  }

  public showFilterMenu(): void {
    this.offersFilterVisible = true;
  }



  filterOffers() {
    this.refreshPage();
  }

  public refreshPage(): void {
    this.updatePages();
    this.updateShownOffers();
    document
      .getElementById('main-page')
      .scroll({ top: 0, left: 0, behavior: 'smooth' });
  }

  private updatePages() {
    this.maxPages = Math.floor(
      this.fts.selectedOffers.length / this.maxOffersPerPage
    );
    if (this.fts.selectedOffers.length % this.maxOffersPerPage !== 0) {
      this.maxPages++;
    }
    this.middlePagesCount =
      this.maxPages - 2 > this.maxMiddlePagesCount
        ? this.maxMiddlePagesCount
        : this.maxPages - 2;
    this.middlePages = [];
    for (let i = 0; i < this.middlePagesCount; i++) {
      this.middlePages.push(i + 2);
    }

    if (this.maxPages - 2 > this.maxMiddlePagesCount) {
      const pagesBeforeSelectedCount = Math.floor(
        (this.middlePagesCount - 1) / 2
      );
      this.canShowLeftDots =
        this.selectedFilteredPageIndex - pagesBeforeSelectedCount > 2;

      const pagesAfterSelectedCount = Math.floor(this.middlePagesCount / 2);

      this.canShowRightDots =
        this.selectedFilteredPageIndex + pagesAfterSelectedCount <
        this.maxPages - 1;

      if (!this.canShowLeftDots) {
        for (let i = 0; i < this.middlePagesCount; i++) {
          this.middlePages[i] = i + 2;
        }
      } else if (!this.canShowRightDots) {
        for (let i = 0; i < this.middlePagesCount; i++) {
          this.middlePages[i] = this.maxPages - (this.middlePagesCount - i);
        }
      } else {
        for (let i = 0; i < this.middlePagesCount; i++) {
          this.middlePages[i] =
            this.selectedFilteredPageIndex + (i - pagesBeforeSelectedCount);
        }
      }
    } else {
      this.canShowLeftDots = false;
      this.canShowRightDots = false;
    }
  }

  private updateShownOffers(): void {
    const startIndex: number =
      (this.selectedFilteredPageIndex - 1) * this.maxOffersPerPage;
    const endIndex: number =
      this.selectedFilteredPageIndex * this.maxOffersPerPage;

    this.shownOffers = [];
    for (let i = startIndex; i < endIndex; i++) {
      if (i < this.fts.selectedOffers.length) {
        this.shownOffers.push(this.fts.selectedOffers[i]);
      }
    }
  }
}
